import { ChevronsLeft, ChevronLeft, ChevronRight, ChevronsRight } from 'lucide-react';
import { NAVY, BORDER_COLOR } from '../../styles/tokens';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/**
 * Bottom-of-table pagination bar.
 * Pairs with usePaginatedSort. Renders "Mostrando X-Y de Z", page size selector,
 * and first/prev/next/last controls. Shows nothing when totalItems === 0.
 */
export default function PaginationBar({
  page, pageSize, totalPages, totalItems,
  onPageChange, onPageSizeChange,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
}) {
  if (totalItems === 0) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);
  const atStart = page <= 1;
  const atEnd = page >= totalPages;
  const btn = (disabled) => ({
    background: disabled ? '#f1f5f9' : '#fff',
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: 6, padding: '4px 6px',
    color: disabled ? '#cbd5e1' : NAVY,
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'inline-flex', alignItems: 'center',
  });

  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      flexWrap: 'wrap', gap: 8,
      marginTop: 10, padding: '8px 4px',
      fontSize: 12, color: '#64748b',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div>
        Mostrando <strong style={{ color: NAVY }}>{start}-{end}</strong> de <strong style={{ color: NAVY }}>{totalItems}</strong>
      </div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <label style={{ fontSize: 11 }}>Por página:</label>
        <select
          value={pageSize}
          onChange={e => onPageSizeChange(Number(e.target.value))}
          style={{
            fontSize: 12, padding: '3px 6px', borderRadius: 6,
            border: `1px solid ${BORDER_COLOR}`, color: NAVY, background: '#fff',
          }}
        >
          {pageSizeOptions.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <button style={btn(atStart)} disabled={atStart} onClick={() => onPageChange(1)} title="Primera página">
          <ChevronsLeft size={14} />
        </button>
        <button style={btn(atStart)} disabled={atStart} onClick={() => onPageChange(page - 1)} title="Anterior">
          <ChevronLeft size={14} />
        </button>
        <span style={{ minWidth: 90, textAlign: 'center', fontSize: 12 }}>
          Página <strong style={{ color: NAVY }}>{page}</strong> de <strong style={{ color: NAVY }}>{totalPages}</strong>
        </span>
        <button style={btn(atEnd)} disabled={atEnd} onClick={() => onPageChange(page + 1)} title="Siguiente">
          <ChevronRight size={14} />
        </button>
        <button style={btn(atEnd)} disabled={atEnd} onClick={() => onPageChange(totalPages)} title="Última página">
          <ChevronsRight size={14} />
        </button>
      </div>
    </div>
  );
}
